import { z } from 'zod';
import { EmailSchema } from './common.js';

/**
 * Body of PATCH /api/v1/admin/email-sender. All fields optional — only the keys
 * present are updated.
 *
 * Pilot constraint: agencies control the From DISPLAY NAME and the reply-to only.
 * The actual From email address stays the shared verified Gmail sender, so we
 * never accept a From address here (setting one per-agency would break
 * SPF/DKIM/DMARC over Gmail). Per-domain sending is deferred Postmark work.
 */
export const UpdateEmailSenderSchema = z
  .object({
    sender_name: z.string().trim().min(1, 'Enter a display name').max(120).optional(),
    reply_to: EmailSchema.optional(),
  })
  .strict();

export type UpdateEmailSenderInput = z.infer<typeof UpdateEmailSenderSchema>;
